import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Text from "@components/Text";
import Stepper from "@components/_Revamp/Stepper";
import ReviewMessageBox from "./components/ReviewMessageBox";
import Accordion from "@pages/EverGreen/Components/Accordion";
import Listing from "@pages/EverGreen/Components/Listing";
import Button from "@pages/EverGreen/Components/Button";
import { useAvivaSelector } from "@redux/hook";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { Helpers, formatDate } from "@utils/helpers";
import Modal from "@components/_Revamp/Modal";
import EditModal from "./components/EditModal";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheet from "@components/_Revamp/BottomSheet";
import MainContainer from "@pages/EverGreen/Components/Container";
import { ROUTE_PATH } from "@static/route-paths";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { format } from "@pages/EverGreen/Helpers/helpers";
import {
  IOccupation,
  SourceOfFunds,
  SourceOfWealth,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { Nationalities } from "@static/nationalities";
import { SCREEN_SIZE } from "@static/screen-size";
import { useScreenSize } from "@pages/EverGreen/Hooks/useScreenSize";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

export interface ReviewProps {}
interface IItem {
  text?: string;
  value: string;
}

export interface EditBtnProps {
  onClick?: (e: any) => void;
}

const Review = () => {
  //TODO : Get previous data from step 1 to 4;

  const everGreenStep1 = useAvivaSelector((state) => state.everGreenStep1);
  const everGreenStep2 = useAvivaSelector((state) => state.everGreenStep2);
  const everGreenStep3 = useAvivaSelector((state) => state.everGreenStep3);

  const countryList = everGreenStep1.staticData.countryList;

  const history = useHistory();

  const [personalDetails, setPersonalDetails] = useState<IItem[]>([]);
  const [planDetails, setPlanDetails] = useState<IItem[]>([]);
  const [mailingAddress, setMailingAddress] = useState<IItem[]>([]);
  const [employmentDetails, setEmploymentDetails] = useState<IItem[]>([]);
  const [taxDetails, setTaxDetails] = useState<IItem[]>([]);
  const [otherTaxDetails, setOtherTaxDetails] = useState<IItem[][]>([]);
  const [pepDetails, setPepDetails] = useState<IItem[]>([]);
  const [farDetails, setFarDetails] = useState<IItem[]>([]);

  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const [editModalData, setEditModalData] = useState<any>(null);
  const { isMobile } = useScreenSize();

  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [aaTracking, setAATracking] = useState<string[]>([]);
  const isAdviserStepEmpty = useAvivaSelector(
    (state) => state.everGreenStep3.financialAdviser.autoAssignAgent
  );
  const isCampaignCode = useAvivaSelector(state=>state.loading.campaignDetail?.product === "DIGITALSAVER")
  const EditComponent = ({ onClick }: EditBtnProps) => {
    return <EditBtnParagraph onClick={onClick}>Edit</EditBtnParagraph>;
  };

  const args = useMemo(() => {
    return {
      theme: EverGreenStyle,
      className: container_with_bg_css,
      title: "Personal Information",
      titleClassName: title_with_bg_css,
      titleColor: isMobile
        ? EverGreenStyle.colors.grey[500]
        : EverGreenStyle.colors.primary,
      titleFontSize: isMobile ? 18 : 20,
      showHeaderBackground: true,
      contentMarginLeft: "0",
      contentMarginRight: "0",
      showBottomLine: false,
      bottomLineColor: "#000",
      showExtraElement: true,
    };
  }, [isMobile]);

  const listingArg = useMemo(() => {
    return {
      headingFontSize: "14px",
      summaryTextFontSize: "14px",
      summaryValueFontSize: "14px",
      listingHeadingFontSize: "14px",
      headerMaxValueWidth: isMobile ? "120px" : "333px",
    };
  }, [isMobile]);

  const displayModal = (e: any, path: string, pageTitle: string) => {
    e.stopPropagation();
    setEditModalVisible(true);
    let obj = {
      title: pageTitle,
      onBackClick: () => {
        setEditModalVisible(false);
      },
      onProceedClick: () => {
        history.push(path + paramCC + analyticParam);
        setEditModalVisible(true);
      },
    };
    setEditModalData(obj);
  };

  useEffect(() => {
    if (isEmpty(everGreenStep2.myInfo)) {
      history.push(ROUTE_PATH.EVER_GREEN_GET_STARTED);
      return;
    } else {
      setPlanDetails([
        {
          value: everGreenStep1.staticData.productName,
        },
        {
          value: "S$" + format(everGreenStep1.quotation.investingAmount),
        },
        { value: everGreenStep1.staticData.premiumTerm },
        { value: "" + everGreenStep1.staticData.policyTerm },
        {
          value:
            "S$" + format(everGreenStep1.quotation.sqsquotation.deathBenefit),
        },
        {
          value:
            "S$" + format(everGreenStep1.quotation.sqsquotation.maturityPayout),
        },
      ]);
      setPersonalDetails([
        { value: everGreenStep2.myInfo.fullName || "" },
        { value: everGreenStep2.myInfo.salutation || "" },
        { value: everGreenStep2.myInfo.firstName || "" },
        { value: everGreenStep2.myInfo.lastName || "" },
        {
          value: everGreenStep2.myInfo.mobileNum
            ? "+65 " +
              everGreenStep2.myInfo.mobileNum?.substring(0, 4) +
              " " +
              everGreenStep2.myInfo.mobileNum?.substring(4, 8)
            : "",
        },
        { value: everGreenStep2.myInfo.emailId || "" },
        {
          value: everGreenStep2.myInfo.dateOfBirth
            ? formatDate(everGreenStep2.myInfo.dateOfBirth)
            : "",
        },
        { value: everGreenStep2.myInfo.nric || "" },
        { value: everGreenStep2.myInfo.nationality || "" },
        { value: everGreenStep2.myInfo.residentialStatus || "" },
        { value: everGreenStep2.myInfo.gender || "" },
        { value: everGreenStep2.myInfo.address.postal },
        { value: everGreenStep2.myInfo.address.unitNo },
        { value: everGreenStep2.myInfo.address.street },
        { value: everGreenStep2.myInfo.address.block },
        { value: everGreenStep2.myInfo.address.building },
      ]);
      setMailingAddress([
        {
          value:
            countryList.find(
              (country) =>
                country.id ===
                (everGreenStep2.myInfo.mailingAddress?.country ||
                  everGreenStep2.myInfo.address.country)
            )?.label || "",
        },
        {
          value:
            everGreenStep2.myInfo.mailingAddress?.postal ||
            everGreenStep2.myInfo.address.postal ||
            "",
        },
        {
          value:
            everGreenStep2.myInfo.mailingAddress?.unitNo ||
            everGreenStep2.myInfo.address.unitNo ||
            "",
        },
        {
          value:
            everGreenStep2.myInfo.mailingAddress?.street ||
            everGreenStep2.myInfo.address.street ||
            "",
        },
        {
          value:
            everGreenStep2.myInfo.mailingAddress?.block ||
            everGreenStep2.myInfo.address.block ||
            "",
        },
        {
          value:
            everGreenStep2.myInfo.mailingAddress?.building ||
            everGreenStep2.myInfo.address.building ||
            "",
        },
      ]);
      setEmploymentDetails([
        { value: everGreenStep3.occupation.selectedOccupation.label },
        { value: everGreenStep3.occupation.employerName },
        { value: everGreenStep3.occupation.natureOfBusiness.label },
        { value: everGreenStep3.occupation.annualIncome.label },
        { value: everGreenStep3.occupation.fcc === "YES" ? "Yes" : "No" },
        {
          value: Object.keys(everGreenStep3.occupation.sourceOfWealth)
            .filter(
              (key) =>
                everGreenStep3.occupation.sourceOfWealth[
                  key as keyof SourceOfWealth
                ] === true
            )
            .map((key) =>
              key === "Others"
                ? everGreenStep3.occupation.sourceOfWealthOthersContent
                : everGreenStep3.occupation?.sourceOfWealthList?.find(
                    (item) => item.id === key
                  )?.text
            )
            .join(", "),
        },
        {
          value: Object.keys(everGreenStep3.occupation.sourceOfFunds)
            .filter(
              (key) =>
                everGreenStep3.occupation.sourceOfFunds[
                  key as keyof SourceOfFunds
                ] === true
            )
            .map((key) =>
              key === "Others2"
                ? everGreenStep3.occupation.sourceOfFundsOthersContent
                : everGreenStep3.occupation?.sourceOfFundsList?.find(
                    (item) => item.id === key
                  )?.text
            )
            .join(", "),
        },
      ]);
      setTaxDetails([
        {
          value:
            everGreenStep3.tax.hasSingaporeTaxNumber === "N" ? "No" : "Yes",
        },
        { value: everGreenStep3.tax.singaporeTaxNumber || "" },
        { value: everGreenStep3.tax.reasonForNoTaxIdentificationNumber || "" },
      ]);
      if (everGreenStep3.tax.otherTax?.length > 0) {
        let taxes: IItem[][] = [];
        everGreenStep3.tax.otherTax.forEach((tax) => {
          taxes.push([
            {
              value:
                Nationalities.find(
                  (nation) => nation.code === tax.countryOfTaxResidence
                )?.description || "",
            },
            { value: tax.hasOtherTaxNumber === "N" ? "No" : "Yes" },
            { value: tax.taxIdentificationNumber },
            { value: tax.reasonForNoTaxIdentificationNumber || "" },
          ]);
        });
        setOtherTaxDetails(taxes);
      }
      setPepDetails([
        { value: everGreenStep3.PEP.isPEP === "YES" ? "Yes" : "No" },
        {
          value:
            everGreenStep3.PEP.isPEP === "YES"
              ? everGreenStep3.PEP.PEPData?.name || ""
              : "",
        },
        {
          value:
            everGreenStep3.PEP.isPEP === "YES"
              ? everGreenStep3.PEPList.find(
                  (item) => item.id === everGreenStep3.PEP.PEPData?.relationship
                )?.label || ""
              : "",
        },
        {
          value:
            everGreenStep3.PEP.isPEP === "YES"
              ? everGreenStep3.PEP.PEPData?.othersContent || ""
              : "",
        },
      ]);
      setFarDetails([
        {
          value:
            everGreenStep3.financialAdviser?.autoAssignAgent ===
            "singlife-adviser"
              ? "Yes, assign an adviser to me"
              : everGreenStep3.financialAdviser?.autoAssignAgent ===
                "no-adviser"
              ? "No, I do not need an adviser"
              : "Yes, I want to assign my own adviser",
        },
        {
          value:
            everGreenStep3.financialAdviser?.autoAssignAgent === "own-adviser"
              ? everGreenStep3.FARData?.code || ""
              : "",
        },
        {
          value:
            everGreenStep3.financialAdviser?.autoAssignAgent === "own-adviser"
              ? everGreenStep3.financialAdviser?.adviserData?.data?.fullName ||
                everGreenStep3.FARData?.name ||
                ""
              : "",
        },
      ]);
    }
  }, [everGreenStep1, everGreenStep2, everGreenStep3, history]);

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
    }
  }, [isLoaded]);

  const planSummarySources = [
    {
      heading: {
        text: "Plan",
        value: `${planDetails[0]?.value ? planDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Premium Amount",
        value: `${planDetails[1]?.value ? planDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Premium Frequency",
        value: `${planDetails[2]?.value ? planDetails[2]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Policy Term",
        value: `${planDetails[3]?.value ? planDetails[3]?.value : "-"} Years`,
      },
    },
    {
      heading: {
        text: "Death Benefit",
        value: `${planDetails[4]?.value ? planDetails[4]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Maturity Benefit",
        value: `${planDetails[5]?.value ? planDetails[5]?.value : "-"}`,
      },
    },
  ];
  const personalInformationSources = [
    {
      heading: {
        text: "Full Name (as per NRIC)",
        value: `${personalDetails[0]?.value ? personalDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Salutation",
        value: `${personalDetails[1]?.value ? personalDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "First Name/Given Name",
        value: `${personalDetails[2]?.value ? personalDetails[2]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Last Name/Family Name",
        value: `${personalDetails[3]?.value ? personalDetails[3]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Mobile Number",
        value: `${personalDetails[4]?.value ? personalDetails[4]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Email",
        value: `${personalDetails[5]?.value ? personalDetails[5]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Date of Birth",
        value: `${personalDetails[6]?.value ? personalDetails[6]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "NRIC/FIN",
        value: `${personalDetails[7]?.value ? personalDetails[7]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Nationality",
        value: `${personalDetails[8]?.value ? personalDetails[8]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Residental Status",
        value: `${personalDetails[9]?.value ? personalDetails[9]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Gender",
        value: `${
          personalDetails[10]?.value ? personalDetails[10]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Postal Code",
        value: `${
          personalDetails[11]?.value ? personalDetails[11]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Unit (If any)",
        value: `${
          personalDetails[12]?.value ? personalDetails[12]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Street Name",
        value: `${
          personalDetails[13]?.value ? personalDetails[13]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Block",
        value: `${
          personalDetails[14]?.value ? personalDetails[14]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Building Name (If any)",
        value: `${
          personalDetails[15]?.value ? personalDetails[15]?.value : "-"
        }`,
      },
    },
  ];

  const mailingAddressResources = useMemo(() => {
    const arr = [
      {
        heading: {
          text: "Postal Code",
          value: `${mailingAddress[1]?.value ? mailingAddress[1]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Unit (If any)",
          value: `${mailingAddress[2]?.value ? mailingAddress[2]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Street Name",
          value: `${mailingAddress[3]?.value ? mailingAddress[3]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Block",
          value: `${mailingAddress[4]?.value ? mailingAddress[4]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Building Name (If any)",
          value: `${mailingAddress[5]?.value ? mailingAddress[5]?.value : "-"}`,
        },
      },
    ];
    if (
      everGreenStep2.myInfo?.mailingAddress?.country &&
      everGreenStep2.myInfo?.mailingAddress?.country !== "SG"
    ) {
      arr.unshift({
        heading: {
          text: "Country",
          value: `${mailingAddress[0]?.value ? mailingAddress[0]?.value : "-"}`,
        },
      });
    }
    return arr;
  }, [everGreenStep2.myInfo?.mailingAddress?.country, mailingAddress]);

  const employmentDetailsResources = [
    {
      heading: {
        text: "Occupation",
        value: `${
          employmentDetails[0]?.value ? employmentDetails[0]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Name of Employer",
        value: `${
          employmentDetails[1]?.value ? employmentDetails[1]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Nature of Business",
        value: `${
          employmentDetails[2]?.value ? employmentDetails[2]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Annual Income",
        value: `${
          employmentDetails[3]?.value ? employmentDetails[3]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Are you a member of senior management or a dealer/trader/counter staff/casino dealer/debt collector in the following industries?",
        value: `${
          employmentDetails[4]?.value ? employmentDetails[4]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Source of Wealth",
        value: `${
          employmentDetails[5]?.value ? employmentDetails[5]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Source of Funds",
        value: `${
          employmentDetails[6]?.value ? employmentDetails[6]?.value : "-"
        }`,
      },
    },
  ];

  const mapTaxReason = (reason: string) => {
    if (reason === "notIssue")
      return "The country does not issue TINs to its residents";
    if (reason === "notRequired") return "TIN is not required";
    if (reason.includes("notObtain"))
      return `Unable to obtain TIN or equivalent number`;
  };

  const taxDeclarationResources = useMemo(() => {
    const itemTaxes = [
      {
        heading: {
          text: "Singapore",
        },
        descriptions: [
          {
            text: "TIN Number",
            value: `${taxDetails[1]?.value ? taxDetails[1]?.value : "N.A"}`,
          },
        ],
      },
    ];
    if (taxDetails?.[2]?.value) {
      itemTaxes[0].descriptions.push({
        text: "Reason",
        value: `${
          taxDetails[2]?.value ? mapTaxReason(taxDetails[2]?.value) : "-"
        }`,
      });
    }
    if (otherTaxDetails.length) {
      otherTaxDetails.forEach((taxDetail) => {
        const item = {
          heading: {
            text: `${taxDetail[0]?.value ? taxDetail[0]?.value : "-"}`,
          },
          descriptions: [
            {
              text: "TIN Number",
              value: `${taxDetail[2]?.value ? taxDetail[2]?.value : "N.A"}`,
            },
          ],
        };
        if (taxDetail?.[3]?.value) {
          item.descriptions.push({
            text: "Reason",
            value: `${
              taxDetail[3]?.value ? mapTaxReason(taxDetail[3]?.value) : "-"
            }`,
          });
        }
        itemTaxes.push(item);
      });
    }
    return itemTaxes;
  }, [otherTaxDetails, taxDetails]);

  const pepResources = [
    {
      heading: {
        text: "Are you or an immediate family member a PEP; or are you a close associate of a PEP?",
        value: `${pepDetails[0]?.value ? pepDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Name of PEP",
        value: `${pepDetails[1]?.value ? pepDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Relationship to Assured",
        value: `${pepDetails[2]?.value ? pepDetails[2]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Details of PEP",
        value: `${pepDetails[3]?.value ? pepDetails[3]?.value : "-"}`,
      },
    },
  ];

  const farResources = [
    {
      heading: {
        text: "Do you need a Financial Adviser Representative to service this policy?",
        value: `${farDetails[0]?.value ? farDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Financial Adviser Representative Code",
        value: `${farDetails[1]?.value ? farDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Name of Adviser",
        value: `${farDetails[2]?.value ? farDetails[2]?.value : "-"}`,
      },
    },
  ];

  //AA on load
  useEffect(() => {
    if (!isAdviserStepEmpty) return;
    trackOnLoad();
  }, []);

  return (
    <>
      <MainContainer
        step={4}
        backButtonPath={ROUTE_PATH.EVER_GREEN_FINANCIAL_ADVISER}
        padding={isMobile ? "24px 0" : undefined}
        backButtonPadding={isMobile ? "0 24px" : undefined}
      >
        <FormContainer>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0"}>
              <Text
                align={"center"}
                theme={EverGreenStyle}
                className={HeaderTitleCss}
              >
                Review your application
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={EverGreenStyle} className={HeaderDescriptionCss}>
                Almost there! Check that all information is correct before
                making payment.
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
        </FormContainer>

        <FormContentContainer>
          <ReviewMessageBox rowGap={"8px"}>
            <Text theme={EverGreenStyle} className={MessageBoxParagraphCss}>
              <b>Note:</b> Pursuant to Section 23(5) of the Insurance Act 1966,
              you are required to disclose in this application form fully and
              faithfully all facts which you know or ought to know. Otherwise
              the insurance effected may be void.
            </Text>
          </ReviewMessageBox>
          <React.Fragment>
            <Accordion
              isExpanded={true}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_QUOTATION,
                      "Plan summary"
                    );
                  }}
                />
              }
              title="Policy Summary"
            >
              <Listing
                {...listingArg}
                sources={planSummarySources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Personal Information"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_MY_INFO +
                        `?transaction_id=${everGreenStep2.myinfoTransactionId}`,
                      "My info"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={personalInformationSources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
                maxHeight="null"
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Mailing Address"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_MAILING_ADDRESS,
                      "Mailing Address"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={mailingAddressResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Employment Details"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_OCCUPATION,
                      "Occupation"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={employmentDetailsResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
                maxHeight="null"
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Tax Residency Declaration"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_TAX_DECLARATION,
                      "Tax Declaration"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={taxDeclarationResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Politically Exposed Person (PEP) Declaration"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_PEP,
                      "Politically Exposed Person"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={pepResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            {!isCampaignCode && <Accordion
              isExpanded={false}
              {...args}
              title="Financial Adviser Representative"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.EVER_GREEN_FINANCIAL_ADVISER,
                      "Financial Adviser Representative"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={farResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>}
          </React.Fragment>
        </FormContentContainer>

        <FormButtonContainer>
          <Button
            onClick={() => {
              history.push(ROUTE_PATH.EVER_GREEN_PAYMENT);
            }}
            width={"360px"}
            variant={"default"}
            theme={EverGreenStyle}
            label={"Proceed to payment"}
          ></Button>
        </FormButtonContainer>
        <BottomSheet />
      </MainContainer>
      {editModalVisible && (
        <Modal className={modalPadding} show={editModalVisible}>
          <EditModal data={editModalData}></EditModal>
        </Modal>
      )}
    </>
  );
};

export default Review;

const EditBtnParagraph = styled.p`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: ${EverGreenStyle.colors.primary};
`;
const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const MessageBoxTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  color: #434343;
`;
const MessageBoxParagraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 180%;
  color: #444444;
  font-size: 14px;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 400;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  transition: all 0.2s ease;
  @media screen and (min-width: 768px) {
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;
const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    margin-bottom: 48px;
  }
`;
const FormContentContainer = styled.div`
  display: block;
  flex-wrap: wrap;
  column-gap: 30px;
  flex-direction: column;
  justify-content: space-evenly;
  margin: auto;
  @media screen and (min-width: 769px) {
    flex-direction: row;
    justify-content: center;
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px 16px 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 100px;
  column-gap: 40px;
  padding: 0 24px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (min-width: 769px) {
    width: 100%;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
    max-width: 300px;
    margin: auto;
  }
`;

const container_with_bg_css = css`
  margin: 24px 0 0 0;
  &nth-child(1) {
    margin: 64px 0 0 0;
  }
`;
const title_with_bg_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  font-size: 20px;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 18px;
  }
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}
export interface MessageNoteProps {
  color?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;
